import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export const Btn = ({ to, href, variant = "primary", children, external, testid, className = "" }) => {
  const ref = useRef(null);
  const move = (e) => {
    if (e.pointerType !== "mouse") return;
    const r = ref.current.getBoundingClientRect();
    ref.current.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.18}px, ${(e.clientY - r.top - r.height / 2) * 0.28}px)`;
  };
  const leave = () => { ref.current.style.transform = ""; };
  const Icon = external ? ArrowUpRight : ArrowRight;
  const props = { ref, className: `btn btn-${variant} ${className}`, onPointerMove: move, onPointerLeave: leave, "data-testid": testid };
  const inner = <><span>{children}</span><Icon size={17} aria-hidden="true" /></>;
  if (to) return <Link to={to} {...props}>{inner}</Link>;
  return <a href={href} {...props} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{inner}</a>;
};
